import { render, staticRenderFns } from "./EloBarLegend.vue?vue&type=template&id=2f4a6f33&"
import script from "./EloBarLegend.vue?vue&type=script&lang=js&"
export * from "./EloBarLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports